import { addYears, differenceInMonths, isPast } from 'date-fns'

export const getTrialStartDate = (studyStartDate: Date | null) => {
  const today = new Date()
  return studyStartDate && isPast(studyStartDate) ? studyStartDate : today
}

export const getTrialEndDate = (primaryCompletionDate: Date | null) => {
  const today = new Date()
  const nextYear = addYears(today, 1)
  return primaryCompletionDate && !isPast(primaryCompletionDate)
    ? primaryCompletionDate
    : nextYear
}

export const getSpotsRemaining = ({
  enrollmentCount,
  primaryCompletionDate,
  studyStartDate,
}: {
  enrollmentCount: number | null
  primaryCompletionDate: Date | null
  studyStartDate: Date | null
}) => {
  const today = new Date()
  const startDate = getTrialStartDate(studyStartDate)
  const endDate = getTrialEndDate(primaryCompletionDate)

  const enrollment = enrollmentCount ?? 350

  const monthsRemaining = differenceInMonths(endDate, today)
  const studyDurationInMonths = differenceInMonths(endDate, startDate)
  const percentageEnrolled =
    (studyDurationInMonths - monthsRemaining) / studyDurationInMonths
  const estimatedEnrolled = Math.round(percentageEnrolled * enrollment)

  const spotsRemaining = Math.min(
    enrollment - estimatedEnrolled,
    Math.round(enrollment * (2 / 3)),
  )
  return { endDate, spotsRemaining }
}
